import { Button } from "@/components/button";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles/common";
import { Box, Center, Divider, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import DOMPurify from "dompurify";
import { useEffect } from "react";
import { useSetPensionNameState } from "../../../shared/client/states/pensionName.state";
import { type FooterProps } from "./types";

export const Footer = ({ logoUrl, pensionInfo, calendar }: FooterProps) => {
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isTablet } = MEDIAS();
    const setPensionName = useSetPensionNameState();
    const { ybs, yeogi } = { ...calendar };
    useEffect(() => {
        if (pensionInfo) setPensionName(pensionInfo?.name.kor);
    }, [pensionInfo]);

    return (
        <S.Wrapper style={{ borderTop: `1px solid ${COLORS.gray[300]}` }}>
            <Center
                w={isTablet ? "100%" : "1184px"}
                justifyContent={isTablet ? "center" : "space-evenly"}
                rowGap={isTablet ? "24px" : ""}
                flexDir={isTablet ? "column" : "row"}
            >
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        PENSION INFO
                    </Text>
                    <Box className="pension_detail_info">
                        <Text>상호 : {pensionInfo?.name.kor}</Text>
                        <Text
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                    ` 주소${pensionInfo?.address.sub ? "1" : ""} : ${pensionInfo?.address.new}`,
                                ),
                            }}
                        ></Text>
                        {pensionInfo?.address.sub && (
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(`주소 : ${pensionInfo?.address.new}`),
                                }}
                            />
                        )}
                        <Text>사업자 번호 : {pensionInfo?.bizNumber}</Text>
                        {ybs?.used && (
                            <Text
                                cursor="pointer"
                                onClick={() => {
                                    window.location.href = `${ybs.url}`;
                                }}
                            >
                                YBS
                            </Text>
                        )}
                        {yeogi?.used && (
                            <Text
                                cursor="pointer"
                                onClick={() => {
                                    window.location.href = `${yeogi.url}`;
                                }}
                            >
                                여기어때 예약
                            </Text>
                        )}
                    </Box>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="56px" alignItems="center" w="320px">
                    <Box bg={`url(${logoUrl})no-repeat center/cover`} w="184px" h="60px" />
                    <Text fontSize="14px">Copyright(C) 2022 MarginMax All Right Reserved</Text>
                </Flex>
                {!isTablet && <Divider orientation="horizontal" w="auto" h="100px" border="1px solid gray" />}
                <Flex flexDir="column" rowGap="16px" textAlign="center" w="320px">
                    <Text fontFamily="Cormorant" fontWeight="700" fontSize="20px">
                        NUMBER INFO
                    </Text>
                    <Flex flexDir="column" rowGap="24px">
                        <Box className="pension_private_info">
                            {pensionInfo?.tel.use && <Text>전화 : {pensionInfo?.tel.number}</Text>}
                            {pensionInfo?.account.use && (
                                <Text
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(`계좌번호 : ${pensionInfo!.account.number}`),
                                    }}
                                />
                            )}
                        </Box>

                        <Button size="tiny" border="none">
                            관리자 로그인
                        </Button>
                    </Flex>
                </Flex>
            </Center>
        </S.Wrapper>
    );
};

const Wrapper = styled.footer`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;

    & .pension_detail_info > p {
        ${FONT("pretendard", 14, 300)}
    }

    & .pension_private_info > p {
        ${FONT("pretendard", 14, 300)}
    }
`;

const S = { Wrapper };
